import Text from '@deprecated-ui/common/Text';
import moment from 'moment';
import Image from 'global/Image';
import If from 'global/ErrorHandlers/If';
import {
  StepperContainer,
  StepperImageFrame,
  StepperItem,
  StepperLabel,
  StepperLine,
} from '../styled';
import { StepperStatus } from '../types';
import { StatusIndicatorMap } from '../constants';

interface Props {
  label: string;
  date: Date;
  status: StepperStatus;
  index: number;
  length: number;
  isActive?: boolean;
  descriptions?: string;
}

export default function TimelineItem({
  label,
  date,
  status,
  index,
  length,
  isActive = false,
  descriptions = '',
}: Props) {
  return (
    <StepperItem>
      <StepperImageFrame>
        <Image src={StatusIndicatorMap[status]} />
        {index < length - 1 ? <StepperLine isActive={isActive} /> : null}
      </StepperImageFrame>
      <StepperContainer>
        <StepperLabel>
          <Text family="bold">{label}</Text>
          <If condition={date}>
            <div>&#x2022;</div>
            <Text color="#858585">
              {moment(date).utc().format('DD MMM YYYY HH:mm')}
            </Text>
          </If>
        </StepperLabel>
        <Text>{descriptions}</Text>
      </StepperContainer>
    </StepperItem>
  );
}
